// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"3f48c19c","258":"50a3b5a2","375":"c105b22b","578":"5232bfc4"}[chunkId] + ".chunk.css";
};